module.exports = __webpack_public_path__ + "img/fivestars.aeb81743.svg";